export var NetworkContractType;
(function (NetworkContractType) {
    NetworkContractType["Train"] = "Train";
    NetworkContractType["Multicall"] = "Multicall";
})(NetworkContractType || (NetworkContractType = {}));
export class Network {
}
export const getNativeToken = (network) => !network ? undefined : network.tokens?.find(t => t.contractAddress === network.nativeTokenAddress);
export class Token {
}
